import type { PlanExternal } from '@helloextend/extend-api-client'

export const getIsWheelsTirePlan = (plan?: PlanExternal): boolean =>
  plan?.contract.category === 'wheel_tire'
